"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utilityFunctions = require("../util/utilityFunctions");

var AbstractPermissionComponent = function AbstractPermissionComponent(_ref) {
  var alternate = _ref.alternate,
      children = _ref.children,
      permission = _ref.permission;
  var alternateOrNull = alternate || null;
  var alternateComponent = (0, _utilityFunctions.isFunction)(alternateOrNull) ? alternateOrNull() : alternateOrNull;
  return permission ? children : alternateComponent;
};

AbstractPermissionComponent.propTypes = {
  alternate: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.element]),
  children: _propTypes.default.element,
  permission: _propTypes.default.bool
};
var _default = AbstractPermissionComponent;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/permission-components/static-1.43/js/components/AbstractPermissionComponent.js
// module id = 242
// module chunks = 209 210 211 212